import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import {
  DEFAULT_DATE_FORMAT,
  formatDate,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { BillingDetailsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/outputs/shared/billing-details.model';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';

interface BankCardProps {
  billingDetails: BillingDetailsModel;
}

export const BankCardComponent = ({
  billingDetails,
}: BankCardProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="bank"
        as={HeadingEnum.H2}
        variant={AccentVariantEnum.Accent2}
        text={t('delmonicos-shared-sdk.outputs-customer.billing-details')}
      />
      <Stack justifyContent="space-between" gap={GapEnum.M}>
        <Text bold>
          {t('delmonicos-shared-sdk.outputs-billing-details.iban')}
        </Text>
        <Text>{billingDetails.iban}</Text>
      </Stack>

      <Stack justifyContent="space-between" gap={GapEnum.M}>
        <Text bold>
          {t('delmonicos-shared-sdk.outputs-billing-details.bic')}
        </Text>
        <Text>{billingDetails.bic}</Text>
      </Stack>
      <Divider />
      <Stack gap={GapEnum.M}>
        <Text bold>
          {t('delmonicos-shared-sdk.outputs-billing-details.mandate')}
        </Text>
        {billingDetails.mandate ? (
          <>
            <Text>
              {formatDate(
                billingDetails.mandate.dateOfSignature,
                i18n,
                DEFAULT_DATE_FORMAT,
              )}
            </Text>
            <Text>{billingDetails.mandate.documentNumber}</Text>
          </>
        ) : (
          <Text>-</Text>
        )}
      </Stack>
    </Card>
  );
};
